import {
	BUTTON_INTERACTION,
	richTextResolver,
} from "@website-builder/utilities-index";

export default (contents, { globalVariableWithURL = [], context = {} }) => {
	const tableOfContents = [];

	const contentTransform = (item) => {
		switch (item?.component) {
			case "blogHeading":
				const hashLink = item?.text
					.replace(/[^a-zA-Z0-9\s]+/g, "")
					.replace(/\s+/g, "-")
					.toLowerCase();
				// Eliminate characters other than alphabets and digits, then replace spaces with hyphens, then convert to lowercase
				if (item?.addToSidebar) {
					tableOfContents.push({
						text: item?.text,
						link: hashLink,
					});
				}
				return {
					component: item?.component,
					text: item?.text,
					hashLink,
				};
			case "textWR":
				return {
					component: item?.component,
					text: richTextResolver(item?.text, globalVariableWithURL),
				};
			case "leanerImage":
				return {
					component: item?.component,
					image: item?.image?.image,
					alt: item?.image?.altTag,
				};
			case "BlogImage":
				return {
					component: item?.component,
					image: item?.image?.image,
					alt: item?.image?.altTag,
					mobileImage: item?.mobileImage?.image || item?.image?.image,
					mobileAlt: item?.mobileImage?.altTag || item?.image?.altTag,
					subtitle: item?.subtitle,
				};
			case "BlogContent":
				return item?.content?.content?.map((blogContentItem) => {
					if (
						blogContentItem?.type === "heading" &&
						blogContentItem?.attrs?.level === 2
					) {
						const headingPlaintextContent = blogContentItem?.content
							?.map(({ text }) => text)
							?.join(" ");
						const transformedHeading = contentTransform({
							component: "blogHeading",
							text: headingPlaintextContent,
							addToSidebar: true,
						});
						return {
							text: richTextResolver(
								{
									type: "doc",
									content: [blogContentItem],
								},
								globalVariableWithURL,
							),
							component: "blogHeadingRichtext",
							hashLink: transformedHeading?.hashLink,
						};
					} else {
						return {
							component: "BlogContent",
							text: richTextResolver(
								{
									type: "doc",
									content: [blogContentItem],
								},
								globalVariableWithURL,
							),
						};
					}
				});
			case "FullWidthSection":
				return contentTransform(item?.components?.[0]);
			case "CTAButton":
				return {
					component: item?.component,
					link: item?.Link,
					event: BUTTON_INTERACTION.CTA_CLICK,
					text: item?.label,
				};
			case "BlogVideo":
				return {
					component: item?.component,
					url: item?.url,
					subtitle: item?.subtitle,
				};
			default:
				console.error("Unknown component type!", item?.component);
				return null;
		}
	};

	return {
		contents: contents?.map?.(contentTransform)?.flatMap((item) => item) || [],
		tableOfContents,
		isHeaderSticky: context?.isHeaderSticky || false,
	};
};
